import { Checkbox } from '@/shared/components/Checkbox';
import { OutlinedDropdown } from '@/shared/components/OutlinedDropdown';
import { TextField } from '@/shared/components/TextField';
import { ToggleButton } from '@/shared/components/ToggleButton';
import CreateLayout from '@/shared/layout/createLayout';
import { useCallback } from 'react';
import { Info } from 'react-feather';
import { showLangToggle, usePermission } from '../../hooks/usePermission';

const PermissionsPage = () => {
  const {
    permissions,
    isPolish,
    setIsPolish,
    isLoading,
    isSubmitting,
    isCancelModalOpen,
    isSnackbarOpen,
    snackbarError,
    validationError,
    isAllSelected,
    isIndeterminate,
    translate,
    handleDropdownChange,
    handleSelectAll,
    handleSubmit,
    handleCancel,
    handleCloseCancelModal,
    handleConfirmCancel,
    handleCloseSnackbar,
  } = usePermission();

  const PermissionsHeader = useCallback(
    () => (
      <div className="flex justify-between">
        <p className="text-titleLarge text-neutral-10">Uprawnienia</p>
        {showLangToggle && (
          <ToggleButton
            checked={isPolish}
            onChange={setIsPolish}
            onText="PL"
            offText="EN"
            label={isPolish ? 'PL' : 'EN'}
          />
        )}
      </div>
    ),
    [isPolish, setIsPolish]
  );

  return (
    <CreateLayout
      isSubmitting={isSubmitting}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      isCancelModalOpen={isCancelModalOpen}
      handleCloseCancelModal={handleCloseCancelModal}
      handleConfirmCancel={handleConfirmCancel}
      isSnackbarOpen={isSnackbarOpen}
      handleCloseSnackbar={handleCloseSnackbar}
      snackbarError={snackbarError}
      Header={PermissionsHeader}
      submitButtonLabel="Zapisz"
      submitButtonLoadingLabel="Zapisywanie…"
    >
      <div className="flex flex-col gap-8">
        <p className="flex items-center text-bodyMedium text-on-surface-variant">
          <Info />
          <span className="ml-2 font-medium">Uwaga:&nbsp;</span>Te uprawnienia
          zostaną przyznane wszystkim użytkownikom klienta.
        </p>
        <div className="w-[24%]">
          <TextField
            label="Rola"
            fullWidth={true}
            value="Klienci"
            disabled={true}
          />
        </div>
        <div className="w-[180px] flex flex-col gap-4">
          <p className="text-bodyLarge text-on-surface-variant">Uprawnienia</p>
          {validationError && (
            <p className="text-bodyMedium text-error">{validationError}</p>
          )}
          <Checkbox
            label={translate('Select All')}
            checked={isAllSelected}
            indeterminate={isIndeterminate}
            onChange={handleSelectAll}
            disabled={isLoading || isSubmitting}
            testId="privilege-select-all"
          />
        </div>
        <div className="flex flex-wrap gap-4 items-start w-full">
          {permissions.map((module, index) => (
            <div
              key={module.title}
              className="w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-11px)] xl:w-[calc(25%-12px)]"
            >
              <OutlinedDropdown
                title={translate(module.title)}
                options={module.options.map((o) => ({
                  ...o,
                  label: translate(o.label),
                }))}
                onChange={(updated) => handleDropdownChange(index, updated)}
                disabled={isLoading || isSubmitting}
                testId={module.title}
              />
            </div>
          ))}
        </div>
      </div>
    </CreateLayout>
  );
};

export default PermissionsPage;
